<template>
  <div>

    <b-row class="ml-0">
      <div v-for="title in titles" :key="title.id">
        <div class="mb-3">
          <b-button class="my-collapse" v-b-toggle="title.id"  @click="changeCustomToggleIcon" >

            <feather-icon :icon="customIcon" size="12" :class="'text-white'" />
            {{ $t(title.name) }}
            <feather-icon :icon="customToggleIcon" size="12" :class="'text-white'" />
          </b-button>
        </div>
      </div>
      <br />

    </b-row>
    <slot ></slot>
  </div>
</template>
<script>

import Vue from 'vue';
import {
  VBToggle, BCollapse, BButton, BCard, BIcon, BRow
} from 'bootstrap-vue'

Vue.directive('b-toggle', VBToggle)
export default {

  name: 'ToggaleCollabsable',
  props: { "titles": { type: Array }, 'customIcon': { type: String, default: "FilterIcon" } },
  components: {
    BButton, BCard, BCollapse, VBToggle, BIcon, BRow

  },
  data(){
    return {
      customToggleIcon:"ArrowRightIcon",
      isOpen:false
    }
    
   

    },
    methods: {
      changeCustomToggleIcon(){
         this.isOpen=!this.isOpen;
         if(this.isOpen){
          this.customToggleIcon="ArrowDownIcon";
         }else{
          this.customToggleIcon="ArrowRightIcon";
         }
      }
    }

  }




</script>
<style scoped>
.my-collapse {
  margin-bottom: -25px;
  z-index: 9999;
  margin-right: 25px;


}
</style>